// ============================================================================
// IMPORTS
// ============================================================================

import ConfigService, { FeatureFlags } from "../services/ConfigService";

// ============================================================================
// APPOINTMENT SETTINGS
// ============================================================================

export const APPOINTMENT_SETTINGS = {
    MIN_HOURS_THRESHOLD: 48, // Minimo ore prima dell'appuntamento per poter prenotare/modificare
};

// ============================================================================
// BOOKING CONFIGURATION
// ============================================================================

/**
 * Tipo assicurazione di default per prenotazioni
 */
export const insurance = "PVT"; // Private insurance

/**
 * ID location/sede di default
 */
export const location = "NMS"; // Default location ID

// ============================================================================
// FEATURE FLAGS
// ============================================================================

/**
 * Mostra/nasconde la tab "Prenotazioni"
 * Legge da variabile d'ambiente REACT_APP_SHOW_PRENOTAZIONI
 */
export const showPrenotazioni = process.env.REACT_APP_SHOW_PRENOTAZIONI === 'true';

/**
 * Mostra/nasconde la tab "Appuntamenti"
 * Legge da variabile d'ambiente REACT_APP_SHOW_APPUNTAMENTI
 */
export const showAppuntamenti = process.env.REACT_APP_SHOW_APPUNTAMENTI === 'true';

/**
 * Mostra/nasconde la tab "Referti OnLine"
 * Legge da variabile d'ambiente REACT_APP_SHOW_REFERTI_ONLINE
 */
export const showRefertiOnline = process.env.REACT_APP_SHOW_REFERTI_ONLINE === 'true';

/**
 * Mostra/nasconde la funzionalità "Registrazione"
 * Legge da variabile d'ambiente REACT_APP_SHOW_REGISTRAZIONE
 */
export const showRegistrazione = process.env.REACT_APP_SHOW_REGISTRAZIONE === 'true';

// ============================================================================
// DYNAMIC FEATURE FLAGS FROM CONFIG.JSON
// ============================================================================

/**
 * Default feature flags (usati se config.json non è disponibile)
 */
const defaultFeatureFlags: FeatureFlags = {
  showPrenotazioni: false,
  showAppuntamenti: false,
  showRefertiOnline: true,
  showRegistrazione: false,
};

/**
 * Ottiene i feature flags dal config.json caricato dinamicamente
 * Se non disponibili, ritorna i valori di default
 */
export function getFeatureFlags(): FeatureFlags {
  const config = ConfigService.getConfig();
  if (config?.featureFlags) {
    return {
      showPrenotazioni: config.featureFlags.showPrenotazioni ?? defaultFeatureFlags.showPrenotazioni,
      showAppuntamenti: config.featureFlags.showAppuntamenti ?? defaultFeatureFlags.showAppuntamenti,
      showRefertiOnline: config.featureFlags.showRefertiOnline ?? defaultFeatureFlags.showRefertiOnline,
      showRegistrazione: config.featureFlags.showRegistrazione ?? defaultFeatureFlags.showRegistrazione,
    };
  }
  return defaultFeatureFlags;
}
